const config = {
  apiKey: "AIzaSyAiro_Ma1VKAFX93hGCy2CjmCTY9FtArxM",
  authDomain: "build-test-app.firebaseapp.com",
  databaseURL: "https://build-test-app.firebaseio.com",
  projectId: "build-test-app",
  storageBucket: "build-test-app.appspot.com"
};

export default config;
